import { ClipboardCheck, ClipboardList, Hash, Stethoscope, Wrench } from 'lucide-react';
import type React from 'react';

/**
 * The appointment types, and the icon each one shows.
 *
 * Its own module because it is data, not a component. It lived in
 * AppointmentDetailsModal.tsx, which meant that file exported a component AND a
 * constant — and React Fast Refresh can only hot-reload a module whose exports
 * are all components. Editing the modal therefore forced a full page reload
 * instead of a refresh, and four other files imported the constant from there,
 * dragging the whole modal into their dependency graph for six strings.
 */
export const APPOINTMENT_TYPES: Array<{ value: string; label: string; icon: React.ElementType }> = [
    { value: 'checkup', label: 'Checkup', icon: ClipboardCheck },
    { value: 'diagnostic', label: 'Diagnostic', icon: Stethoscope },
    { value: 'consultation', label: 'Consultation', icon: ClipboardList },
    { value: 'repair', label: 'Repair', icon: Wrench },
    { value: 'mot', label: 'MOT', icon: Hash },
    { value: 'other', label: 'Other', icon: ClipboardList },
];
